import * as React from 'react';
import { Field } from 'react-final-form';

interface OnFieldValueChangeProps {
	children: (props: OnFieldValueChangeChildrenProps) => React.ReactNode;
	field: string;
}

interface OnFieldValueChangeChildrenProps {
	value: any;
}

/**
 * Component that gives you the value of a field whenever it changes
 *
 * @class WhenFieldChanges
 * @extends {React.Component<OnFieldValueChangeProps>}
 */
class OnFieldValueChange extends React.Component<OnFieldValueChangeProps> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { field } = this.props;

		return (
			// in react-final-form, <Field /> is really just a subscription to a specific field, based on `name`
			// this is pretty much the same as a <FormSpy /> but for a specific field only.
			<Field name={field} subscription={{ value: true }}>
				{(props) => {
					const {
						input: { value },
					} = props;

					return this.props.children({ value });
				}}
			</Field>
		);
	}
}

export default OnFieldValueChange;
